interface ErrorState {
	message: string;
	show: boolean;
}

export interface TermsCheckboxState {
	value: boolean;
	error: ErrorState;
	valid: boolean | null;
}

export type Action =
	| { type: 'SET_TC_VALUE'; payload: boolean }
	| { type: 'SET_TC_ERROR'; payload: string }
	| { type: 'REMOVE_TC_ERROR' }
	| { type: 'SHOW_TC_ERROR' }
	| { type: 'HIDE_TC_ERROR' };

const Reducer = (state: TermsCheckboxState, action: Action): TermsCheckboxState => {
	switch (action.type) {
		case 'SET_TC_VALUE':
			return {
				...state,
				value: action.payload,
			};
		case 'SET_TC_ERROR':
			return {
				...state,
				error: { ...state.error, message: action.payload },
			};
		case 'REMOVE_TC_ERROR':
			return {
				...state,
				error: { ...state.error, message: '' },
			};
		case 'SHOW_TC_ERROR':
			return {
				...state,
				error: { ...state.error, show: true },
			};
		case 'HIDE_TC_ERROR':
			return {
				...state,
				error: { ...state.error, show: false },
			};
		default:
			return state;
	}
};

export default Reducer;
